'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { useRouter, usePathname, Link } from '@/i18n/navigation';
import Image from 'next/image';
import { useMetadata } from '@/hooks';
import Logo from '@/assets/img/logo.svg';
const BrandLogo = () => {
  const $ = _c(8);
  const {
    title
  } = useMetadata();
  const router = useRouter();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname || $[1] !== router) {
    t0 = e => {
      if (pathname === "/") {
        e.preventDefault();
        router.refresh();
      }
    };
    $[0] = pathname;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleClick = t0;
  let t1;
  if ($[3] !== title) {
    t1 = <Image src={Logo} alt={title} loading="eager" quality={100} priority={true} />;
    $[3] = title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== handleClick || $[6] !== t1) {
    t2 = <Link href="/" className="select-none" onClick={handleClick}>{t1}</Link>;
    $[5] = handleClick;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};
export default BrandLogo;